import React, { useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useIntegrationsStore } from '../../../stores/use-integrations-store';
import { toast } from 'react-toastify';
import DynamicIntegrationForm from './DynamicIntegrationForm';
import Modal from '../../../components/Modal';
import { filteredEmptyData } from '../../../utils/filteredEmptyData';
import { editIntegration } from '../../../api/api';
import dayjs from 'dayjs';

const IntegrationEditForm = ({ showModal, setShowModal, deviceId, id, integrationKey, defaultValues }) => {
  const { integrationsType, fetchIntegrations } = useIntegrationsStore();
  const methods = useForm({ mode: 'onTouched', shouldUnregister: true, defaultValues });
  const selectedConfiguration = useMemo(() => {
    if (integrationsType && integrationKey) {
      const selectIntegration = integrationsType?.find((item) => item.key === integrationKey);
      return selectIntegration?.config?.schema;
    }
  }, [integrationsType, integrationKey]);

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues]);

  const handleSave = async (data) => {
    try {
      if (data.date) {
        data.date = dayjs().date(Number(data.date)).format('YYYY-MM-DD');
      }
      const config = filteredEmptyData(data);
      await editIntegration({ config, integrationKey, deviceId, integrationId: id });
      toast.success('Интеграция обновлена');
      setShowModal(false);
      await fetchIntegrations();
    } catch (err) {
      toast.error(err?.error || 'Произошла ошибка при сохранении', { hideProgressBar: false });
    }
  };

  return (
    <Modal
      showModal={showModal}
      saveCb={methods.handleSubmit(handleSave)}
      setShowModal={setShowModal}
      closeCb={() => setShowModal(false)}
      title="Редактирование интеграции">
      <FormProvider {...methods}>{<DynamicIntegrationForm mode={'edit'} configuration={selectedConfiguration} />}</FormProvider>
    </Modal>
  );
};

export default IntegrationEditForm;
